module.exports = __webpack_public_path__ + "img/logo.59e8bd3a.png";